document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.faq-navigation-item').forEach(faqNavigationItem => {
        faqNavigationItem.addEventListener('click', (event) => {
            event.target.parentNode.classList.toggle('active');
            for (const sibling of event.target.parentNode.parentNode.children) {
                if (sibling !== event.target.parentNode) {
                    sibling.classList.remove('active');
                }
            }
            for (const faqItem of document.getElementById('faq-items').children) {
                if (faqItem.id === event.target.dataset.id) {
                    faqItem.classList.remove('hidden')
                } else {
                    faqItem.classList.add('hidden');
                }
            }
        });
    });

    Shopify.accordion('.faq-header');
});
